import { render, staticRenderFns } from "./shareShop.vue?vue&type=template&id=a0861110&scoped=true"
import script from "./shareShop.vue?vue&type=script&lang=js"
export * from "./shareShop.vue?vue&type=script&lang=js"
import style0 from "./shareShop.vue?vue&type=style&index=0&id=a0861110&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0861110",
  null
  
)

export default component.exports